export default "__VITE_ASSET__BaMoWNyw__"